import * as React from "react";
import {createElement} from "react";
import {Alert, Color} from "@material-ui/lab";
import {Grid, Paper, Typography} from "@material-ui/core";

interface FormattedAlertProps {
    severity?: Color;
    title: string;
    info: string;
}

export function FormattedAlert(props: FormattedAlertProps) {
    const {severity, title, info} = props;
    return (
        <Paper>
            <Alert severity={severity}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Typography variant="body1" style={{fontWeight: 'bolder'}}>{title}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1">{info}</Typography>
                    </Grid>
                </Grid>
            </Alert>
        </Paper>
    );
}
